import { useEffect } from 'react';
import { useLocation, useNavigate } from "@/lib/router-compat";
import { resolveRedirect } from '@/lib/redirectResolver';
import { pushDataLayer } from '@/lib/gtm';

/**
 * Global redirect handler component
 * Intercepts route changes and performs redirects if configured
 */
export function GlobalRedirectHandler() {
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    const checkRedirect = async () => {
      const currentPath = location.pathname;
      
      // Skip redirect check for admin pages and special routes
      if (
        currentPath.startsWith('/admin') ||
        currentPath.startsWith('/auth') ||
        currentPath === '/zum-anbieter' ||
        currentPath === '/gå-til'
      ) {
        return;
      }

      const result = await resolveRedirect(currentPath);
      
      if (result.found && result.to_path) {
        // Track redirect in GTM
        pushDataLayer('redirect_hit', {
          from_path: currentPath,
          to_path: result.to_path,
          redirect_type: result.redirect_type || 301,
          redirect_source: result.source || 'unknown'
        });

        // Perform redirect
        navigate(result.to_path, { replace: true });
      }
    };

    checkRedirect();
  }, [location.pathname, navigate]);

  return null;
}
